import React from 'react';
import { variant } from '~/theme';
import ChevronRight from '~/icons/chevron.svg';
import { CloseBanner } from './components/CloseBanner/CloseBanner';
import { Flex } from '~/shared/components/Flex';
import { Link as LinkType } from '~/lib/data-contract';
import { MaxWidth } from '~/shared/components/MaxWidth';
import { Text, Link } from '~/shared/components';
import styles from './Banner.module.scss';
import clsx from 'clsx';
import styled from '@emotion/styled';
import { ResetButton } from '../Button/ResetButton';

const StyledMaxWidth = styled(MaxWidth)<{ textColor?: string; backgroundColor?: string }>`
    color: ${(props) => props.textColor};
    background-color: ${(props) => props.backgroundColor};
`;

const StyledLink = styled(Link)<{ textColor?: string }>`
    color: ${(props) => props.textColor};
`;

export type CampaignBannerProps = {
    /**
     * Variant Top/Campaign/Basket of the Banner
     */
    variant?: variant;
    /**
     * Prop to add an onClick Event
     */
    onClick?: () => void;
    /**
     * Prop to pass child Component
     */
    onCloseBanner?: () => void;
    /**
     * Color of the Banner text
     */
    textColor: string;
    /**
     * color of the Banner Background
     */
    backGroundColor: string;
    /**
     * Banner Text
     */
    bannerText?: string;
    /**
     * Prop to add the close botton(only wokrs on Mobile)
     */
    withCloseBanner?: boolean;
    /**
     * Prop to add an onClick Event
     */
    bannerLink?: LinkType;
    /**
     * Prop to know if is desktop Display
     */
    desktop?: boolean;
    /**
     * Prop to pass child Component
     */
    childComponent?: JSX.Element;
    className?: string;
};

export const Banner = (props: CampaignBannerProps) => {
    const {
        onClick,
        variant,
        withCloseBanner,
        onCloseBanner,
        textColor,
        backGroundColor,
        bannerLink,
        bannerText,
        childComponent,
        className,
        desktop,
    } = props;

    switch (variant) {
        case 'top': {
            return (
                <div
                    className={clsx(styles.topBannerContainer, className)}
                    style={{ backgroundColor: backGroundColor }}
                >
                    <StyledMaxWidth className={styles.topBanner} textColor={textColor}>
                        <Text
                            as="span"
                            className={styles.topBannerText}
                            onClick={onClick}
                            color={textColor}
                        >
                            {bannerText}
                        </Text>
                    </StyledMaxWidth>
                </div>
            );
        }
        case 'campaign': {
            return (
                <>
                    <StyledMaxWidth
                        className={clsx(styles.campaignBanner, className)}
                        textColor={textColor}
                        backgroundColor={backGroundColor}
                    >
                        <Flex justifyContent="center" grow>
                            <StyledLink
                                href={bannerLink?.url}
                                target={bannerLink?.target}
                                title={bannerLink?.title}
                                className={clsx(styles.campaignBannerTextLink, {
                                    [styles.desktop]: desktop,
                                })}
                                textColor={textColor}
                            >
                                {bannerText}
                                <ResetButton
                                    tabIndex={-1}
                                    aria-label={bannerLink?.title}
                                    className={styles.iconButtonBanner}
                                >
                                    <ChevronRight />
                                </ResetButton>
                            </StyledLink>
                        </Flex>

                        {withCloseBanner && (
                            <CloseBanner textColor={textColor} onCloseBanner={onCloseBanner} />
                        )}
                    </StyledMaxWidth>
                </>
            );
        }
        default: {
            return (
                <>
                    <StyledMaxWidth
                        className={clsx(styles.campaignBanner, className)}
                        textColor={textColor}
                        backgroundColor={backGroundColor}
                    >
                        <Flex justifyContent="center" alignItems="center" grow>
                            {childComponent}
                        </Flex>
                        {withCloseBanner && (
                            <CloseBanner textColor={textColor} onCloseBanner={onCloseBanner} />
                        )}
                    </StyledMaxWidth>
                </>
            );
        }
    }
};
